/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var TextBlockIcon = createIcon("TextBlockIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#171717';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6.867V6.4A1.4 1.4 0 016.9 5h10.267a1.4 1.4 0 011.4 1.401v.467M12.033 5v14m-2.8 0h5.6",
    stroke: _color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "1",
    y: "1",
    width: "22",
    height: "22",
    rx: "2",
    stroke: _color,
    strokeWidth: "1.5"
  }));
}, {
  "replaceColor": true
});